import { JSX } from "react";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { CONFIDENCE_LEVEL_TOOLTIP } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { PgrConfidenceTierDefinition } from "@app/shared/confidence-tier/pgrConfidenceTierDefinition";
import {
  CONFIDENCE_TIER_NO_DATA,
  CONFIDENCE_TIER_NO_DATA_LABEL,
  resolveTierLabel,
} from "@app/shared/confidence-tier/confidenceTierLookup";
import { useConfidenceTierDefinitions } from "@app/shared/confidence-tier/useConfidenceTierDefinitions";

/** One option per configured tier, keyed by tier index, then "No Data". */
export const buildConfidenceTierDropdownItems = (definitions: PgrConfidenceTierDefinition[] | null): DropdownItem<number>[] =>
  definitions == null
    ? []
    : [
      ...definitions.map((definition, index) => ({
        key: index,
        name: resolveTierLabel(definition.label),
      })),
      { key: CONFIDENCE_TIER_NO_DATA, name: CONFIDENCE_TIER_NO_DATA_LABEL },
    ];

interface ConfidenceTierFilterProps {
  selectedValues: DropdownItem<number>[];
  setSelectedValues: (selectedValues: DropdownItem<number>[]) => void;
  testId: string;
  title: string;
}

const ConfidenceTierFilter = (props: ConfidenceTierFilterProps): JSX.Element => {
  const { definitions } = useConfidenceTierDefinitions();

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === 0 ? "All" : null}
      hideSearch={true}
      items={buildConfidenceTierDropdownItems(definitions)}
      onSelectionChanged={(selectedValues: DropdownItem<number>[]) => { props.setSelectedValues(selectedValues) }}
      label={props.title}
      selectedItems={props.selectedValues}
      showTooltipOnOverflow={true}
      testId={props.testId}
      validationTooltipContent={CONFIDENCE_LEVEL_TOOLTIP}
    />
  )
}

export default ConfidenceTierFilter;
